<template>
<td colspan="1" style="position:relative">

    <Avatar :type="'icon'" :size="'medium'" :theme-color="color">
  <font-awesome-icon :icon="icon" >
    
  </font-awesome-icon>
</Avatar>

</td>
</template>
<script>
/*
</span>  <span :class="spanClass">
*/

import { Avatar } from '@progress/kendo-vue-layout';
export default {
  components: {
    Avatar,
  },
  props: {
   checked:Boolean
  },
  computed: {
    icon(){
      return this.checked?"check":"times";
    },
    color() {
      return this.checked?"primary":"error";
    },
    spanClass() {
      return {
       'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!this.checked,"action_success":this.checked
        
      };
    }
  }
};
</script>